/**
 * Өдрийн дэлгэрэнгүйн нэг хэсэг — дээр нь зураас, h3 гарчиг, тоо.
 *
 * ⚠️ `SectionSplit`-ийн жижиг саарал шошго урт модалд харагдахгүй
 *    байсан: 6–7 хэсэг дараалахад хаана юу эхэлж байгааг нүд олдоггүй.
 */

import type { ReactNode } from 'react';
import { formatQty } from '@boots/domain';

export function DayBlock({ title, count, children }: {
  title: string;
  count?: number;
  children: ReactNode;
}) {
  return (
    <section className="flex flex-col gap-2.5 border-t border-hair pt-3.5">
      <h3 className="text-h3">
        {title}
        {count === undefined ? null : (
          <span className="num ml-2 text-meta font-normal text-ink-3">{formatQty(count)}</span>
        )}
      </h3>
      {children}
    </section>
  );
}
